import React from 'react'
import { Form, Input } from 'antd'
import { Box, FormControlLabel, Switch, Typography } from '@mui/material'

import type { BlockPayload } from '../../../types'
import { getYouTubeVideoId } from '../utils'

interface Props {
  payload: { url?: string; width?: string; height?: string; fullWidth?: boolean }
  onChange: (payload: BlockPayload) => void
}

export const VideoBlock: React.FC<Props> = ({ payload: p, onChange }) => {
  const videoId = getYouTubeVideoId(p?.url ?? '')
  const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : null

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Form.Item label="ลิงก์ YouTube" style={{ marginBottom: 0 }}>
        <Input
          placeholder="https://www.youtube.com/watch?v=... หรือ https://youtu.be/..."
          value={p?.url ?? ''}
          onChange={(e) =>
            onChange({
              url: e.target.value,
              width: p?.width ?? '560',
              height: p?.height ?? '315',
              fullWidth: p?.fullWidth ?? false,
            })
          }
          allowClear
        />
      </Form.Item>

      {embedUrl && (
        <Box sx={{ mt: 1 }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            พรีวิว
          </Typography>
          <Box
            sx={{
              position: 'relative',
              width: p?.fullWidth ? '100%' : undefined,
              maxWidth: '100%',
              overflow: 'hidden',
              borderRadius: 1,
              bgcolor: 'action.hover',
              ...(p?.fullWidth
                ? {
                    aspectRatio: '16/9',
                    '& iframe': { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 },
                  }
                : {
                    width: p?.width ? (/\d+$/.test(String(p.width)) ? `${p.width}px` : p.width) : 560,
                    height: p?.height ? (/\d+$/.test(String(p.height)) ? `${p.height}px` : p.height) : 315,
                    '& iframe': { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 },
                  }),
            }}
          >
            <iframe
              src={embedUrl}
              title="YouTube preview"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
        </Box>
      )}

      <FormControlLabel
        control={
          <Switch
            checked={p?.fullWidth ?? false}
            onChange={(e) =>
              onChange({
                url: p?.url ?? '',
                width: p?.width ?? '560',
                height: p?.height ?? '315',
                fullWidth: e.target.checked,
              })
            }
            color="primary"
          />
        }
        label="Full Width — ความกว้าง 100% ความสูงปรับอัตโนมัติ 16:9"
      />

      {!p?.fullWidth && (
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <Form.Item label="ความกว้าง (px)" style={{ marginBottom: 0 }}>
            <Input
              placeholder="560"
              value={p?.width ?? ''}
              onChange={(e) =>
                onChange({
                  url: p?.url ?? '',
                  width: e.target.value,
                  height: p?.height ?? '315',
                  fullWidth: p?.fullWidth ?? false,
                })
              }
            />
          </Form.Item>
          <Form.Item label="ความสูง (px)" style={{ marginBottom: 0 }}>
            <Input
              placeholder="315"
              value={p?.height ?? ''}
              onChange={(e) =>
                onChange({
                  url: p?.url ?? '',
                  width: p?.width ?? '560',
                  height: e.target.value,
                  fullWidth: p?.fullWidth ?? false,
                })
              }
            />
          </Form.Item>
        </Box>
      )}
    </Box>
  )
}
